import { styled, Typography } from '@mui/material';

export const MarkdownWrapper = styled(Typography)({
	listStylePosition: 'inside',
	'h1, h2': { lineHeight: '70px' },
});
